module.exports = __webpack_public_path__ + "static/img/26836.3269597.png";


//////////////////
// WEBPACK FOOTER
// ./src/common/images/productCenter/dxzg/26836.png
// module id = WuPz
// module chunks = 0